import { INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND } from '@lexical/list';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { FORMAT_TEXT_COMMAND } from 'lexical';
import type { FunctionComponent } from 'react';
import { Fragment, useCallback } from 'react';

import { Button } from '../button/Button';
import { IconBoldText, IconBulletListText, IconNumberedListText } from '../icons';
import { useToolbarState } from './useToolbarState';

type ToolbarPluginProps = {
    readonly disabled?: boolean;
};

export const ToolbarPlugin: FunctionComponent<ToolbarPluginProps> = ({ disabled = false }) => {
    const [editor] = useLexicalComposerContext();
    const { isBold, isBulletList, isNumberedList } = useToolbarState(editor);

    const handleBold = useCallback(() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
    }, [editor]);

    const handleBulletList = useCallback(() => {
        if (isBulletList) {
            editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
        } else {
            editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);
        }
    }, [editor, isBulletList]);

    const handleNumberedList = useCallback(() => {
        if (isNumberedList) {
            editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
        } else {
            editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined);
        }
    }, [editor, isNumberedList]);

    return (
        <Fragment>
            <Button
                disabled={disabled}
                iconOnly={true}
                isActive={isBold}
                size="sm"
                variant="ghost"
                onClick={handleBold}
            >
                <IconBoldText />
            </Button>
            <Button
                disabled={disabled}
                iconOnly={true}
                isActive={isBulletList}
                size="sm"
                variant="ghost"
                onClick={handleBulletList}
            >
                <IconBulletListText />
            </Button>
            <Button
                disabled={disabled}
                iconOnly={true}
                isActive={isNumberedList}
                size="sm"
                variant="ghost"
                onClick={handleNumberedList}
            >
                <IconNumberedListText />
            </Button>
        </Fragment>
    );
};
